import { render, staticRenderFns } from "./Aimodel.vue?vue&type=template&id=4ec0e726&scoped=true&"
import script from "./Aimodel.vue?vue&type=script&lang=js&"
export * from "./Aimodel.vue?vue&type=script&lang=js&"
import style0 from "./Aimodel.vue?vue&type=style&index=0&id=4ec0e726&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec0e726",
  null
  
)

export default component.exports